import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "./index.css";
import App from "./App";

// tell Axios to always send cookies
axios.defaults.withCredentials = true;

/**
 * Preloads images by creating new Image objects.
 *
 * @param {string[]} urls - Array of image URLs to preload.
 */
function preloadImages(urls) {
  urls.forEach((url) => {
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = url;
    document.head.appendChild(link);
  });
}

// List all the image URLs that are used in any part of your app.
// Update the following array with the paths to the images you want to preload.
const imagesToPreload = [
  // images folder
  "./assets/images/ElasticSearch_Logo.png",
  "./assets/images/Live_Well_Collaborative_Logo.png",
  "./assets/images/LWC-Login-Full-Image.svg",

  // logos folder
  //Priority:
  "./assets/logos/elastic-info.svg",
  "./assets/logos/work-management.svg",
  "./assets/logos/send-query.svg",
  "./assets/logos/stop-query.svg",

  "./assets/logos/back.svg",
  "./assets/logos/close-button-dark.svg",
  "./assets/logos/close-button.svg",
  "./assets/logos/check-button-dark.svg",
  "./assets/logos/check-button.svg",

  "./assets/logos/pan-bottom.svg",
  "./assets/logos/download.svg",
  "./assets/logos/document.svg",
  "./assets/logos/next-page.svg",
  "./assets/logos/next-page-dark.svg",
  "./assets/logos/previous-page.svg",
  "./assets/logos/previous-page-dark.svg",

  "./assets/logos/add-user.svg",
  "./assets/logos/manage-users.svg",
  "./assets/logos/manage-sponsors-dark.svg",
  "./assets/logos/manage-projects-dark.svg",
  "./assets/logos/manage-users-dark.svg",
  "./assets/logos/manage-sponsors.svg",
  "./assets/logos/manage-projects.svg",
  "./assets/logos/edit-icon.svg",
  "./assets/logos/delete-button.svg",
  "./assets/logos/delete-icon.svg",

  // "./assets/logos/create.svg",
  // "./assets/logos/work-management_old.svg",
  // "./assets/logos/regenerate-response.svg",
];

// Start preloading images as soon as possible.
preloadImages(imagesToPreload);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
